import { DefaultButton, PrimaryButton } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import "./UserColumn.css"
import { useContext } from "react";
import userContext from "../../context/users/UserContext";
import { USERTYPES } from "../Constants";
import { getEnv } from "../../helpers/EnvHelper";

export const FirmAdminUserColumns = (userId, handleActionButton, handleUserClick, handleLockButton,openPasswordReset) => {

  const {t} = useTranslation();
  const childTrPadding = (getEnv("REACT_APP_HYBRID_MODE") == "false") ? "15px 0px 15px 10px" : "15px 10px";
  const rowTrPadding = "0px 10px";
  const{roles}=useContext(userContext);

  return [
    {
      id: "username",
      style: { width: "22%", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: {padding: childTrPadding, textAlign: "left", width: "22%", boxSizing:'border-box'},
      headerClass:"break-word",
      classChildName:
          "break-word cursor-pointer",
      header: () => (
        <span className="">Details</span>
      ),
      accessor: "clients",
      accessorKey: "clients",
      show: true,
      cell: (info) =>  <>
      <div>
          <div className="user-heading">{t("user.username")}</div>
          <div className="user-sub-heading">{info.row.original.username}</div>
      </div>

      <div className="user-mt-10">
          <div className="user-heading">Full Name</div>
          <div className="user-sub-heading">{info.row.original.firstName}{" "}{info.row.original.lastName}</div>
      </div>
    </>,
    },
    {
      id: "email",
      style: { width: "26%", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: {padding:childTrPadding, textAlign: "left", width: "26%", boxSizing:'border-box'},
      headerClass:"break-word",
      classChildName:
          "break-word cursor-pointer",
      header: () => (
        <span className="">Contact Details</span>
      ),
      accessor: "email",
      accessorKey: "email",
      show: true,
      cell: (info) =>  <>
      <div>
          <div className="user-heading">{t("user.email")}</div>
          <div className="user-sub-heading">{info.row.original.email}</div>
      </div>

      <div className="user-mt-10">
          <div className="user-heading">{t("user.mobile")}</div>
          <div className="user-sub-heading">{info.row.original.mobile}</div>
      </div>

  </>,
    },
    {
      id: "action",
      style: { width:"52%", display:'flex', height:'80px', alignItems:'center', boxSizing:'border-box', padding:rowTrPadding, flexWrap:roles[0]===USERTYPES.ADMIN ?"wrap": "nowrap" },
      headerStyle: {padding:childTrPadding, textAlign: "left", width: "52%", boxSizing:'border-box'},
      headerClass:"break-word",
      classChildName:
          "break-word cursor-pointer",
      header: () => (
        <span >{t("supervisor.action")}</span>
      ),
      accessor: "action",
      accessorKey: "action",
      show: true,
      cell: (cell) => <>
      {userId != cell.row.original.id && (
        <>
        {/* <p style={{margin:'0px'}}>{!cell.row.original.active ? "Inactive" : "Active"}</p> */}
        {!cell.row.original.active ?<PrimaryButton
          text={ "Activate"}
          //text={cell.row.values.action}
          onClick={(event) =>
            handleActionButton(event, cell.row.original.id, cell)
          }
          style={{
            width: "80px",
            padding: "0",
          }}
        />
        :
        <DefaultButton
        text={"Deactivate"}
        //text={cell.row.values.action}
        onClick={(event) =>
          handleActionButton(event, cell.row.original.id, cell)
        }
        style={{
          width: "80px",
          padding: "0",
        }}
      />}

        {!cell.row.original.accountNonLocked ?<PrimaryButton
            text={ "Unlock"}
            //text={cell.row.values.action}
            onClick={(event) =>
              handleLockButton(event, cell.row.original.id, cell)
            }
            style={{
              width: "80px",
              padding: "0",
              marginLeft: "10px"
            }}
          />
          :
          <DefaultButton
          text={"Lock"}
          //text={cell.row.values.action}
          onClick={(event) =>
            handleLockButton(event, cell.row.original.id, cell)
          }
          style={{
            width: "80px",
            padding: "0",
            marginLeft: "10px"
          }}
        />
        }
            {roles[0] === USERTYPES.ADMIN &&
              <DefaultButton
                text={"Reset Password"}
                onClick={(event) =>
                  openPasswordReset(
                    event,
                    `${cell.row.original.firstName || ""} ${cell.row.original.lastName || ""}`.trim(),cell.row.original.username
                  )
                }
                style={{
                  width: "120px",
                  padding: "0",
                  marginLeft: "10px"
                }}
              />
            }
      </>
      )}
    </>,
    },
  ];
}
